import { useState } from "react";
import { Typography } from "@mui/material";
import UploadDataButton from "@/Layouts/components/Buttons/UploadDataButton";
import { TUploadProfilePictureProps } from "../../types/UserProfile";

export default function UploadProfilePicture(props: Readonly<TUploadProfilePictureProps>) {
	const [name, setName] = useState<string>("");

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();
		let file = null;

		if (e.target.files) {
			file = e.target.files[0];
		}

		if (file) {
			const reader = new FileReader();
			reader.onload = () => {
				if (props.onChangeImage) {
					setName(file.name);
					props.onChangeImage(reader.result as string, file);
				}
			};

			reader.readAsDataURL(file);
		}
	};

	return (
		<>
			<UploadDataButton onChange={onChange} title={"Choose File"} className="!rounded-[25px]" accept=".png, .jpeg, .jpg" />
			<Typography className="filename-copy !text-[#666] !font-[PTSansProNarrow] !ml-[16px] absolute left-[19%] pt-[8px] !text-[14px]">
				{name}
			</Typography>
		</>
	);
}
